import { MultiSelectCombobox } from '@/shared/components/ui/multi-select-combobox';
import { Switch } from '@/shared/components/ui/switch';
import { useSharedCounties } from './useSharedGeography';

type StateCountiesEditorProps = {
  stateCode: string;
  stateName: string;
  allCounties: boolean;
  countyIds: string[];
  onToggleAllCounties: (all: boolean) => void;
  onCountiesChange: (countyIds: string[]) => void;
};

/** Per-state county scoping inside the coverage dialog. */
export function StateCountiesEditor({
  stateCode,
  stateName,
  allCounties,
  countyIds,
  onToggleAllCounties,
  onCountiesChange,
}: StateCountiesEditorProps) {
  const { data: counties = [], isLoading } = useSharedCounties(stateCode);

  return (
    <div className="space-y-3 rounded-lg border border-border-subtle bg-white p-3">
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm font-medium text-text-primary">{stateName}</span>
        <label className="flex items-center gap-2 text-sm text-text-secondary">
          All counties
          <Switch
            checked={allCounties}
            onCheckedChange={(checked) => onToggleAllCounties(checked === true)}
          />
        </label>
      </div>
      {!allCounties ? (
        <MultiSelectCombobox
          options={counties}
          value={countyIds}
          onChange={onCountiesChange}
          loading={isLoading}
          placeholder={`Select counties in ${stateName}`}
          searchPlaceholder="Search counties…"
          emptyText="No counties found"
          maxVisibleBadges={3}
        />
      ) : null}
    </div>
  );
}
